import { createHashRouter } from 'react-router-dom'
import { getPlatForm } from '../controller/common';
// import App from '../App';
import { Content } from "../pages/content";
import ErrorPage from '../pages/ErrorPage/ErrorPage';
import Totur from '../pages/toturial';

export default  createHashRouter([{
    path: '/',
    element: <Content />,
    id:'root',
    loader: () => { 
        return { platform:getPlatForm() }
    }
},{
    path:'/error/:msg',
    element:<ErrorPage/>
},{
    path:'/totur',
    element:<Totur/>
}])
